import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './SeeDefinitions.module.scss';

type Props = {
  additionalText?: string;
  className?: string;
};

const SeeDefinitions: FC<Props> = ({ additionalText, className }) => (
  <div className={classNames(styles['legal-disclaimer'], className)}>
    See Definitions below for additional information. {additionalText}
  </div>
);

export default SeeDefinitions;
